// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1XDNA","head":"Table_head__2WXMc","col":"Table_col__10kJG"};